import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { Token } from '../api/tokens/types';
import { PaymentType, ResultDepositData } from '../types/common';
import { CryptoLimits } from '../types/cryptoLimits';
import { MoneyboxBalance } from '../types/moneybox';
import { NormalizedPaymentServices } from '../utils/normalizePaymentServices';
import { STORE_PROPS } from './constants';

export interface PaymentsState {
  [STORE_PROPS.PAYMENT_SERVICES]: NormalizedPaymentServices;
  [STORE_PROPS.ACTIVE_SERVICE_ID]: number | null;
  [STORE_PROPS.ACTIVE_PAYMENT_TYPE]: PaymentType | null;
  [STORE_PROPS.IS_PAYMENT_SERVICES_LOADED]: boolean;
  [STORE_PROPS.USER_TOKENS]: Token[];
  [STORE_PROPS.RESULT_DEPOSIT_DATA]: ResultDepositData;
  [STORE_PROPS.MONEYBOX_BALANCE]: MoneyboxBalance[];
  [STORE_PROPS.RECOMMENDED_DEPOSIT_AMOUNT]: number | null;
  [STORE_PROPS.CRYPTO_LIMITS]: CryptoLimits | null;
  [STORE_PROPS.IS_SERVICE_ALLOWED]: {
    isAllowed: boolean;
    isLoaded: boolean;
  };
}

export const initialState: PaymentsState = {
  [STORE_PROPS.PAYMENT_SERVICES]: {} as NormalizedPaymentServices,
  [STORE_PROPS.ACTIVE_SERVICE_ID]: null,
  [STORE_PROPS.ACTIVE_PAYMENT_TYPE]: null,
  [STORE_PROPS.IS_PAYMENT_SERVICES_LOADED]: false,
  [STORE_PROPS.USER_TOKENS]: [],
  [STORE_PROPS.RESULT_DEPOSIT_DATA]: null,
  [STORE_PROPS.MONEYBOX_BALANCE]: [],
  [STORE_PROPS.RECOMMENDED_DEPOSIT_AMOUNT]: null,
  [STORE_PROPS.CRYPTO_LIMITS]: null,
  [STORE_PROPS.IS_SERVICE_ALLOWED]: {
    isAllowed: false,
    isLoaded: false
  }
};

export const usePaymentsStore = createHookStore<PaymentsState>(
  STORE_NAMES.PAYMENTS,
  initialState
);
